import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=6d4ebe83&scoped=true&"
import script from "./ContactDetail.vue?vue&type=script&lang=js&"
export * from "./ContactDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ebe83",
  null
  
)

export default component.exports